<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="associativaForm">
<form [formGroup]="associativaForm" (ngSubmit)="update();">
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome/Nome'"
			[valueInput]="parte.nominativo"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Matricola'" [valueInput]="parte.matricola"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Codice fiscale'" [valueInput]="parte.codiceFiscale"></div>
	</div>
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'"
			[valueInput]="parte.ragioneSociale"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Partita iva'" [valueInput]="parte.partitaIva"></div>
	</div>
	<div class="row">
		<div comboModInput class="col-sm-6" [mandatory]="false"
			[control]="associativaForm.controls['categoriaAltraParte']"
			[labelInput]="'Categoria'" formControlName="categoriaAltraParte"
			[objectReference]="request.categoriaAltraParte"
			(onReturn)="categoriaAltraParteChanged($event)"
			[optionsCombo] ="categorie" [ngModel]="request.categoriaAltraParte"></div>

		<!--<div checkBoxRadio class="col-sm-4" [labelInput]="'Cliente'"
			[idInput]="inserimento ? 'cliente-ins' : 'cliente-mod'" formControlName="cliente"
			[objectReference]="request?.cliente"
			[control]="associativaForm.controls['cliente']"
			(onReturn)="request.cliente = $event"></div>-->
	</div>
	<div class="row">
		<!--<div datePickerInput class="col-sm-4" [mandatory]="true"
			[control]="associativaForm.controls['dataAssociazione']"
			[labelInput]="'Data associazione'" formControlName="dataAssociazione"
			[(ngModel)]="request.dataAssociazione"></div>-->
		<div comboModInput class="col-sm-4"
			[labelInput]="'Parte (se legale di controparte)'" formControlName="controparte"
			[objectReference]="request.controparte"
			(onReturn)="request.controparte = $event"
			[labelOption]="'parte.nominativo'"
			[submitPending]="request.categoriaAltraParte?.label !== 'LEGALE DI CONTROPARTE'"
			[optionsCombo] ="controparti"></div>

		<div checkBoxRadio class="col-sm-4" [labelInput]="'Rinunciatario'"
			[idInput]="inserimento ? 'ritirato-ins' : 'ritirato-mod'" formControlName="ritirato"
			[control]="associativaForm.controls['ritirato']"
			[objectReference]="request?.ritirato"
			(change)="request.dataTermine=undefined;"
			(onReturn)="request.ritirato = $event"></div>

		<div datePickerInput class="col-sm-4" [labelInput]="'Data rinuncia'"
			[submitPending]="!request.ritirato"
			formControlName="dataTermine" [(ngModel)]="request.dataTermine"
      [mandatory]="!!request.ritirato"></div>

	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="request.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton [disabled]="!associativaForm.valid"
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'">
	</div>
</form>
</ng-template>
